<template>
  <div>
    <myHeader></myHeader>
    <div class="web-body">
      <div class="about-div">
        <div class="product-box" style="margin-bottom: 200px">
          <div class="about-title text-left">公司简介</div>
          <div class="about-text">
            上海韧玩网络科技有限公司成立于2019年，秉承“带给用户完美的娱乐感受”的宗旨，以技术领先，创意活跃，品控严格的研发团队为基础，将对游戏的热爱，充满想像力的构思和丰富的制作经验融入到产品的制作当中，努力追求为用户创造完美的娱乐体验。
            目前，公司在各小游戏平台、国内和海外iOS市场持续打造众多爆款，并获得腾讯、百度、头条等平台推荐，总用户量超2亿并在不断快速增长中！
          </div>
        </div>
      </div>
    </div>
    <myFooter></myFooter>
  </div>
</template>

<script>
  import myFooter from './myFooter';
  import myHeader from './myHeader';

  export default {
    name: "about_company",
    components: {
      myFooter, myHeader
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/about_company.vue